import { FormField } from "@/components/elements/FormField";
import { Switch } from "@/components/elements/Switch";
import { Textarea } from "@/components/elements/Textarea";
import { TCompanyApplicationForm } from "@/features/renew-visa/types/companyApplicationForm";
import { background, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box, Stack, styled, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export type TUpdateDocumentFreeInputCardProps = {
  readonly?: boolean;
};

export const UpdateDocumentFreeInputCard: FC<TUpdateDocumentFreeInputCardProps> = ({ readonly }) => {
  const methods = useFormContext<TCompanyApplicationForm>();
  const { control } = methods;
  const isRequiredFreeInput = useWatch({ control, name: "isRequiredFreeInput" });
  const freeInputValue = useWatch({ control, name: "freeInput" }) || "";
  const characterCount = freeInputValue.length;

  return (
    <>
      <Stack flexDirection="row" my={3} gap={3} alignItems="center">
        <Typography variant="body14" color={text.secondary} sx={{ whiteSpace: "nowrap" }}>
          フリー入力欄を表示
        </Typography>
        <FormField control={control} name="isRequiredFreeInput">
          <StyledSwitch
            disabled={readonly}
            onChange={(_: unknown, checked: boolean) => {
              if (!checked && !readonly) {
                methods.setValue("freeInput", null);
              }
            }}
          />
        </FormField>
      </Stack>
      {isRequiredFreeInput && (
        <Stack borderRadius={rounded.sm} border={`1px solid ${divider.middle}`} overflow="hidden">
          <Box bgcolor={background.secondary} py={1.5} px={2}>
            <Typography variant="sub16Bold">フリー入力欄</Typography>
          </Box>
          <Stack gap={2} py={2} px={3} borderTop={`1px solid ${divider.middle}`} bgcolor={background.white}>
            <Typography variant="body14" color={text.secondary}>
              入管申請における特記・連絡事項がある場合は、ご記入ください。
            </Typography>
            <FormField control={control} name="freeInput" noLabel={true}>
              <Textarea readonly={readonly} disabled={!isRequiredFreeInput} />
              <Typography variant="cap12" color={text.secondary} sx={{ textAlign: "right" }}>
                {characterCount}/300文字
              </Typography>
            </FormField>
          </Stack>
        </Stack>
      )}
    </>
  );
};

const StyledSwitch = styled(Switch)`
  width: 52px;
  height: 28px;
  & .MuiSwitch-thumb {
    width: 24px;
    height: 24px;
  }
  & .MuiSwitch-switchBase.Mui-checked {
    transform: translateX(24px);
  }
`;
